// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2IO8U","colCheckbox":"styles_colCheckbox__2Ck-J"};